import styled from "styled-components";
import materialUI from "material-UI";
import colors from "constants/color";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 400px;
  background: #ffffff;
  border-radius: 8px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
`;

export const Header = styled.div``;

export const Body = styled.div``;

export const TextTitle = styled.p`
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  text-align: left;
  color: #101828;
`;

export const TextDescription = styled.p`
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  letter-spacing: 0.05em;
  text-align: left;
  color: #101828;
`;

export const ContentRowCutted = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 8px;
  width: 100%;
  border: 1px dashed #999999;
  border-radius: 16px;
  cursor: pointer;
  :hover {
    background-color: #f5f5f5;
  }
`;

export const ContentRowCuttedNoAction = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  gap: 8px;
  width: 100%;
  border: 1px dashed #999999;
  border-radius: 16px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

export const Button: any = styled.button`
  display: flex;
  width: ${(props: any) => props.width || "100%"};
  height: ${(props: any) => props.height || "100%"};
  border: ${(props: any) => props.border || "none"};
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 44px;
  border-radius: 8px;
  background-color: ${(props) => props.color || "#2d5bff"};
  :hover {
    cursor: pointer;
  }
  :disabled {
    cursor: not-allowed;
  }
`;

export const TextButton = styled.p`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  color: ${(props) => props.color || "#2d5bff"};
`;

export const ContentDocument = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  gap: 8px;
  width: 100%;
  background-color: #f5f5f5;
  border-radius: 16px;
`;

export const ContentInfoDocument = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #2d5bff;
  border-radius: 16px;
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4363633;
  border-radius: 8px;
  min-width: 40px;
  min-height: 40px;
  cursor: pointer;
`;

export const TextUpload = styled.p`
  font-family: Roboto;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
  color: black;
  opacity: 87%;
`;

export const MultLineField = styled.div`
  position: relative;
  margin-top: 8px;
  width: 100%;
  .button-file {
    width: 100%;
    height: 43px;
    border-radius: 8px;
    color: ${colors.Mediumgrey};
    text-transform: none;
    border: 1px solid ${colors.Mediumgrey};
    border-style: dashed;
    display: inline-flex;
    flex-wrap: wrap;
  }
`;

export const LabelText = styled.span`
  display: flex;
  flex-direction: row;
  font-size: 14px;
  line-height: 150%;
  color: #333333;
  font-family: Inter-Medium;
  margin-bottom: 5px;

  p {
    color: red;
    margin-left: 4px;
  }
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 2px;
  label {
    display: none;
  }
  legend {
    span {
      display: none;
    }
  }
  .MuiInputBase-adornedEnd {
    min-height: 42px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 2px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: ${colors.primary} !important;
    }
  }
  &.input-disabled {
    background-color: ${colors.gray100};
    input {
      color: ${colors.grey1};
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.LigthGrey};
    }
  }
`;

export const CountText = styled.span`
  font-family: Inter;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  color: ${colors.grey1};
  background: ${colors.White};
  position: absolute;
  right: 20px;
  bottom: 10px;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props.space}px !important;
`;

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;
